export const priceCurrency = (price) => {
  // Format the price as currency
  const formattedPrice = new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: "AED",
  }).format(Math.abs(price));

  return price < 0
    ? `${formattedPrice.replace("AED", "AED-")}`
    : formattedPrice;
};

export const preventValueUpdateOnScroll = (e) => {
  return e.target.addEventListener(
    "wheel",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );
};

export const macrosBarDynamicPercentage = (macro, totalOfMacros = 100) => {
  // Calculate the percentage of the given macro
  const percentage = (Number(macro) / totalOfMacros) * 100 || 0;

  return percentage;
};
